<div class="page-wrapper">
    <div class="wizard-wrapper__header">
        <app-header
                [headerText]="'ONBOARDING.WELCOME.HEADER_TITLE' | translate"
                [headerParagraph]="'ONBOARDING.WELCOME.HEADER_TEXT' | translate"
                [ttsIconState]="ttsIconState"
                [repeatButtonDisabled]="repeatButtonDisabled"
                [showHeaderControls]="showHeaderControls"
                [leaveButton]="true"
                [leaveButtonLabel]="'GENERAL.LOGOUT' | translate"
                (playFromStartAudioEvent)="play()"
                (readTextEvent)="readText()"
                (leaveIndication)="logout()">
        </app-header>
    </div>
    <div role="main" class="wizard-wrapper__content">
        <app-display-welcome-page
                [disableResume]="disableResume"
                [isAdmin]="isAdmin"
                [isPatient]="isPatient"
                [isDoctor]="isDoctor"
                [isEditor]="isEditor"
                [isSuperAdmin]="isSuperAdmin"
                [hasConsumedConsents]="hasConsumedConsents"
                [isAudioMode]="autoTextRead"
                (nextStepEvent)="nextStep($event)">
        </app-display-welcome-page>
    </div>
</div>
